var _style, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMainScreenBgr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 491,
    viewBox: "0 0 1512 491",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000129926799385649606890000014501382963059583923_);}\n\t.st1{opacity:0.3;}\n\t.st2{fill:#9AF0F7;}\n\t.st3{fill:none;stroke:#7ACBDD;stroke-width:17;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1443,
    cy: 374,
    r: 136
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1329,
    cy: 483,
    r: 136
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 960,
    cy: 492,
    r: 136
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 761,
    cy: 431,
    r: 136
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 640,
    cy: 534,
    r: 136
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 310,
    cy: 431,
    r: 136
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 133,
    cy: 374,
    r: 136
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 69,
    cy: 223,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 341,
    cy: 255,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 485,
    cy: 438,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 697,
    cy: 294,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1027,
    cy: 359,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1255,
    cy: 359,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1529,
    cy: 223,
    r: 72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1426,
    cy: 215,
    r: 63.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1201,
    cy: 428,
    r: 63.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 900,
    cy: 347,
    r: 63.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 350,
    r: 63.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 246,
    cy: 284,
    r: 63.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 56,
    cy: 139,
    r: 63.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 265,
    cy: 123,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 478,
    cy: 224,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 828,
    cy: 224,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1101,
    cy: 336,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1242,
    cy: 223,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1527,
    cy: 41,
    r: 32.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 100,
    cy: 401,
    r: 136
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 214,
    cy: 510,
    r: 136
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 583,
    cy: 519,
    r: 136
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 782,
    cy: 458,
    r: 136
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 903,
    cy: 561,
    r: 136
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1233,
    cy: 458,
    r: 136
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1410,
    cy: 401,
    r: 136
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1474,
    cy: 250,
    r: 72
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1202,
    cy: 282,
    r: 72
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1058,
    cy: 465,
    r: 72
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 846,
    cy: 321,
    r: 72
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 328,
    cy: 406,
    r: 72
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 14,
    cy: 250,
    r: 72
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 117,
    cy: 242,
    r: 63.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 262,
    cy: 395,
    r: 63.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 643,
    cy: 374,
    r: 63.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1024,
    cy: 401,
    r: 63.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1297,
    cy: 311,
    r: 63.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1487,
    cy: 166,
    r: 63.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1278,
    cy: 150,
    r: 32.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1065,
    cy: 251,
    r: 32.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 715,
    cy: 251,
    r: 32.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 442,
    cy: 363,
    r: 32.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 301,
    cy: 250,
    r: 32.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 16,
    cy: 68,
    r: 32.5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1136.3,
    cy: 619.33,
    r: 136
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1366.8,
    cy: 609.37,
    r: 136
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1531.8,
    cy: 568.11,
    r: 136
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -0.40297,
    cy: 583.76,
    r: 136
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 403,
    cy: 559,
    r: 136
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainScreenBgr);
export default __webpack_public_path__ + "static/media/main-screen-bgr.a6d33076cc194d1ff8298fbccb0867cd.svg";
export { ForwardRef as ReactComponent };